import { httpClient } from '../client';
import { logger } from '../../../utils/logger';
import { ApiErrorHandler } from '../error.handler';
import { BaseEndpoint } from './base.endpoint';

class DashboardEndpoints extends BaseEndpoint {
  private static instance: DashboardEndpoints;

  private constructor() {
    super('organisations');
  }

  static getInstance(): DashboardEndpoints {
    if (!DashboardEndpoints.instance) {
      DashboardEndpoints.instance = new DashboardEndpoints();
    }
    return DashboardEndpoints.instance;
  }

  async dashboardData(organizationId: string): Promise<any> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<any>(`${this.basePath}/${organizationId}/dashboard`, {
        headers,
      });

      return response.data.data;
    } catch (error) {
      logger.error('Failed to fetch Dashboard Datas:', error);
      return ApiErrorHandler.handle(error);
    }
  }
}

export const dashboardEndpoints = DashboardEndpoints.getInstance();
